interface ProductPrice {
  calculatedPrice: {
    unitPrice: number
    listPrice?: {
      price?: number
    } | null
  }
}

interface PriceResult {
  price: number
  discountedPrice: number
}

/*
 * This function returns normal price and discount price (if any) of the product.
 */
export const getPrices = (product?: ProductPrice | null): PriceResult => {
  if (!product) {
    return { price: 0, discountedPrice: 0 }
  }

  const discountedPrice = product.calculatedPrice.unitPrice || 0
  const price = product.calculatedPrice?.listPrice?.price || product.calculatedPrice.unitPrice

  return {
    price,
    discountedPrice,
  }
}
